import httpClient from "Api/httpClient";

const END_POINT = "/entity_emails";

const getEntityEmails = (payload) => {
    let body = "";
    if (payload.body) body = payload.body;
    return httpClient.get(END_POINT, { retryTimes: 3, params: body }); // useCahe: true, retryTimes: 3, throttle: true
};

const getEntityEmail = (entity_emails_id) => {
    if (!entity_emails_id) return;
    const SINGLE_END_POINT = END_POINT + "/" + entity_emails_id;
    return httpClient.get(SINGLE_END_POINT);
};

const printEntityEmail = (entity_emails_id) => {
    if (!entity_emails_id) return;
    const SINGLE_END_POINT = END_POINT + "/print?entity_emails_id=" + entity_emails_id;
    return httpClient.get(SINGLE_END_POINT);
};

const createEntityEmails = (payload) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    return httpClient.post(END_POINT, body);
};

const updateEntityEmails = (payload, entity_emails_id) => {
    let body = "";
    if (payload.body) body = JSON.stringify(payload.body);
    const UPDATE_END_POINT = END_POINT + "/" + entity_emails_id;
    return httpClient.patch(UPDATE_END_POINT, body);
};

const deleteEntityEmails = (entity_emails_id) => {
    const DELETE_END_POINT = END_POINT + "/" + entity_emails_id;
    return httpClient.delete(DELETE_END_POINT, { retryTimes: 3 });
};

export { getEntityEmails, getEntityEmail, printEntityEmail, createEntityEmails, updateEntityEmails, deleteEntityEmails };
